import axios from "axios";

export function getApiLoadErrorDetail(error: unknown, endpoint: string): string {
    if (!axios.isAxiosError(error)) {
        return `Заявката към ${endpoint} не върна данни.`;
    }

    const status = error.response?.status;
    const payload = error.response?.data;

    if (status === 401 || status === 419) {
        return "Сесията е изтекла. Влез отново в приложението.";
    }

    if (status === 403) {
        return "Нямате достъп до този клиентски профил.";
    }

    if (error.code === "ECONNABORTED") {
        return "Заявката изтече. Провери SQL сървъра и backend кеша.";
    }

    if (!error.response) {
        return `Backend недостъпен. Провери дали \`http://api.crm\` отговаря (Vite proxy към ${endpoint}).`;
    }

    if (payload && typeof payload === "object" && "message" in payload) {
        const message = String((payload as { message?: unknown }).message ?? "").trim();

        if (message !== "") {
            return message;
        }
    }

    if (typeof payload === "string" && payload.trim() !== "") {
        return payload.trim();
    }

    if (status === 404) {
        return `HTTP 404 за ${endpoint}. Провери дали Laravel backend е стартиран и маршрутът съществува.`;
    }

    if (status) {
        return `HTTP ${status} за ${endpoint}.`;
    }

    return `Заявката към ${endpoint} не върна данни.`;
}
